import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import apiClient from '../api/client';
import { useLanguage } from '../context/LanguageContext';
import './Auth.css';

function VerifyEmail() {
  const { token } = useParams();
  const { t, language } = useLanguage();
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage(t('verificationLinkExpired'));
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const res = await apiClient.post('/auth/verify-email', { token, lang: language });
        if (!cancelled) {
          setStatus('success');
          setMessage(res.data?.message || t('emailVerifiedSuccess'));
        }
      } catch (err) {
        if (!cancelled) {
          setStatus('error');
          setMessage(err.response?.data?.error || t('verificationLinkExpired'));
        }
      }
    })();

    return () => { cancelled = true; };
  }, [token, language, t]);

  return (
    <div className="auth-page container">
      <div className="auth-card">
        <h1>{t('verifyEmailTitle')}</h1>

        {status === 'loading' && (
          <p className="auth-subtext">{t('loading')}</p>
        )}

        {status === 'success' && (
          <>
            <p className="auth-subtext success-message">{message}</p>
            <div className="auth-actions">
              <Link to="/my-account" className="btn btn-primary">
                {t('backToAccount')}
              </Link>
            </div>
          </>
        )}

        {status === 'error' && (
          <>
            <p className="auth-subtext error-message">{message}</p>
            <div className="auth-actions">
              <Link to="/my-account" className="btn btn-primary">
                {t('backToAccount')}
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;
